import digitalData from 'digital-data';
import { BROWSE, SEARCH, FILTER } from '../constants';
import { getState, setState } from '../analytics-state';

export const getFiltersRefinementsAnalytics = ({ breadCrumbs, searchReport = {}, metadata = {} }) => {

  let { sortOrder = '', sortBy, startIndex, keyword } = searchReport;
  const pageNumber = (startIndex / 24) + 1;
  const { storeFilter } = metadata;
  const productFilter = storeFilter?.toUpperCase() === 'ALL' ? 'all products' : 'in store';

  // function sortItems(selectedFilters) { Not sure if we need to sort stuff
  //   let sortedFilters = [];
  //   let temp = selectedFilters.slice(0);
  //   if (orderOfRefinements) {
  //     orderOfRefinements.forEach((ref) => {
  //       const lowercaseDimensionLabel = ref.dimensionName && ref.dimensionName.toLowerCase();
  //       const lowercaseRefinementLabel = ref.label && ref.label.toLowerCase();
  //       const nextRef = temp.find((val) => val.value === lowercaseRefinementLabel
  //         && val.type === lowercaseDimensionLabel);
  //       if (nextRef) {
  //         sortedFilters.unshift(nextRef);
  //         temp.splice(temp.indexOf(nextRef), 1);
  //       }
  //     });
  //   }
  //   // if user refreshes or loses their orderOfRefinements some other way,
  //   // this preappends remaining selected refinements
  //   temp.forEach((ref) => {
  //     sortedFilters.unshift(ref);
  //   });
  //   return sortedFilters;
  // }

  function filterItems() {
    const selectedFilters = [];
    let filterHeader = '';
    const crumbs = (breadCrumbs || []).filter((crumb) => {
      return crumb?.deselectUrl && crumb?.dimensionName;
    });
    crumbs.forEach((crumb = {}, index) => {
      if (!crumb?.dimensionName) return;

      const lowercaseDimensionLabel = crumb?.dimensionName?.toLowerCase();
      const lowercaseRefinementLabel = crumb?.label?.toLowerCase();

      if (lowercaseDimensionLabel === 'get it fast') {
        filterHeader = 'get it fast';
      } else if (crumb.isVisualNav) {
        filterHeader = 'top filters';
      } else { filterHeader = 'other filters'; }

      selectedFilters.push({
        type: lowercaseDimensionLabel,
        value: lowercaseRefinementLabel,
        position: `left rail:${lowercaseDimensionLabel}:${index + 1}`,
        selectionMethod: 'all'
      });
    });
    // sort? do we need this
    return selectedFilters;
  }

  switch (sortBy?.toUpperCase()) {
  case 'PRICE':
    if (sortOrder.toUpperCase() === 'ASC') {
      sortBy = 'price low to high';
    } else if (sortOrder.toUpperCase() === 'DESC') {
      sortBy = 'price high to low';
    }
    break;
  case 'MOSTPOPULAR':
    sortBy = 'most popular';
    break;
  case 'TOPSELLERS':
    sortBy = 'top sellers';
    break;
  case 'TOPRATED':
    sortBy = 'top rated products';
    break;
  case 'BESTMATCH':
    sortBy = 'best match';
    break;
  default:
    sortBy = '';
  }

  const ddoEvent = {
    category: {
      primaryCategory: keyword ? SEARCH : BROWSE
    },

    displayAttributes: {
      pageNumber,
      productsAvailability: productFilter,
      sortBy,
      viewType: 'grid'
    },

    eventInfo: {
      eventName: 'filter by'
    },

    filter: filterItems() || [],

    isReported: true,
    sourceIndex: 0
  };

  return ddoEvent;
};

export const filtersAndRefinements = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('@@FILTERS-REFINEMENTS/CLICK', (payload) => {
    if (window.isDebugMode) {
      console.log(
        '%c @@FILTERS-REFINEMENTS/CLICK is deprecated.',
        'background: red; color: black', payload
      );
    }
  });

  window.LIFE_CYCLE_EVENT_BUS.on('filters-refinements.publish', ({ output }) => {
    digitalData.event.push(getFiltersRefinementsAnalytics(output));
  });

  window.LIFE_CYCLE_EVENT_BUS.on('filters-refinements.click', function () {
    setState({
      ...getState(),
      pageTransitionEvent: FILTER
    });
  });
};
